<template>
    <b-container class="mt-4" fluid>
        <b-card class="mx-3 mb-3">
            <template v-slot:header>
                <i class="fa fa-tags fa-fw mr-2"></i>Qu&eacute; es una cookie
            </template>
            <p>
                Una <i>cookie</i> es un fichero de texto <b>inofensivo</b> que se almacena en su navegador cuando visita
                casi cualquier página web.
                La utilidad de la <i>cookie</i> es que la web sea capaz de recordar su visita cuando vuelva a navegar
                por esa página.
                Aunque mucha gente no lo sabe las <i>cookies</i> se llevan utilizando desde hace 20 años, cuando
                aparecieron los primeros navegadores
                para la World Wide Web.
            </p>
        </b-card>

        <b-card class="mx-3 mb-3">
            <template v-slot:header>
                <i class="fa fa-tags fa-fw mr-2"></i>Qu&eacute; no es una cookie
            </template>
            <p>
                No es un virus, ni un troyano, ni un gusano, ni spam, ni spyware, ni abre ventanas pop-up.
            </p>
        </b-card>

        <b-card class="mx-3 mb-3">
            <template v-slot:header>
                <i class="fa fa-tags fa-fw mr-2"></i>Qu&eacute; informaci&oacute;n almacena una cookie
            </template>
            <p>
                Las cookies no suelen almacenar información sensible sobre usted, como tarjetas de crédito o
                datos bancarios, fotografías, su DNI o información personal, etc. Los datos que guardan son
                de carácter técnico, preferencias personales, personalización de contenidos, etc.
            </p>
            <p>
                El servidor web no le asocia a usted como persona si no a su navegador web. De hecho, si usted navega
                habitualmente
                con Internet Explorer y prueba a navegar por la misma web con Firefox o Chrome verá que la web no se da
                cuenta que es usted la misma persona porque en realidad está asociando al navegador, no a la persona.
            </p>
        </b-card>

        <b-card class="mx-3 mb-3">
            <template v-slot:header>
                <i class="fa fa-tags fa-fw mr-2"></i>Qu&eacute; informaci&oacute;n almacena una cookie
            </template>
            <p>
                Las cookies no suelen almacenar información sensible sobre usted, como tarjetas de crédito o
                datos bancarios, fotografías, su DNI o información personal, etc. Los datos que guardan son
                de carácter técnico, preferencias personales, personalización de contenidos, etc.
            </p>
            <p>
                El servidor web no le asocia a usted como persona si no a su navegador web. De hecho, si usted navega
                habitualmente
                con Internet Explorer y prueba a navegar por la misma web con Firefox o Chrome verá que la web no se da
                cuenta que es usted la misma persona porque en realidad está asociando al navegador, no a la persona.
            </p>
        </b-card>

        <b-card class="mx-3 mb-3">
            <template v-slot:header>
                <i class="fa fa-tags fa-fw mr-2"></i>Qu&eacute; tipos de cookies existen
            </template>
            <ul>
                <li>
                    <b>Cookies técnicas</b>: Son las más elementales y permiten, entre otras cosas, saber cuándo
                    está navegando un humano o una aplicación automatizada, cuándo navega un usuario anónimo y
                    uno registrado, tareas básicas para el funcionamiento de cualquier web dinámica.
                </li>
                <li>
                    <b>Cookies de análisis</b>: Recogen información sobre el tipo de navegación que está realizando,
                    las secciones que más utiliza, productos consultados, franja horaria de uso, idioma, etc.
                </li>
                <li>
                    <b>Cookies publicitarias</b>: Muestran publicidad en función de su navegación, su país de
                    procedencia, idioma, etc.
                </li>
            </ul>
        </b-card>

        <b-card class="mx-3 mb-3">
            <template v-slot:header>
                <i class="fa fa-tags fa-fw mr-2"></i>Qu&eacute; son las cookies propias y las de terceros
            </template>
            <p>
                Las cookies propias son las generadas por la página que está visitando y las de terceros son las
                generadas por servicios o proveedores externos como Facebook, Twitter, Google, etc.
            </p>
        </b-card>

        <b-card class="mx-3 mb-3">
            <template v-slot:header>
                <i class="fa fa-tags fa-fw mr-2"></i>Qu&eacute; ocurre si desactivo las cookies
            </template>
            <p>Para que entienda el alcance que puede tener desactivar las cookies le mostramos unos ejemplos:</p>
            <ul>
                <li>No podrá compartir contenidos de esa web en Facebook, Twitter o cualquier otra red social.</li>
                <li>El sitio web no podrá adaptar los contenidos a sus preferencias personales, como suele ocurrir en
                    las tiendas online.
                </li>
                <li>No podrá acceder al área personal de esa web, como por ejemplo Mi cuenta, o Mi perfil o Mis
                    pedidos.
                </li>
                <li> Tiendas online: Le será imposible realizar compras online, tendrán que ser telefónicas o visitando
                    la tienda
                    física si es que dispone de ella.
                </li>
                <li>No será posible personalizar sus preferencias geográficas como franja horaria, divisa o idioma.</li>
                <li>El sitio web no podrá realizar analíticas web sobre visitantes y tráfico en la web, lo que
                    dificultará que la web sea competitiva.
                </li>
                <li>No podrá escribir en el blog, no podrá subir fotos, publicar comentarios, valorar o puntuar
                    contenidos.
                    La web tampoco podrá saber si usted es un humano o una aplicación automatizada que publica spam.
                </li>
                <li>No se podrá mostrar publicidad sectorizada, lo que reducirá los ingresos publicitarios de la web.
                </li>
                <li>Todas las redes sociales usan cookies, si las desactiva no podrá utilizar ninguna red social.</li>
            </ul>
        </b-card>

        <b-card class="mx-3 mb-3">
            <template v-slot:header>
                <i class="fa fa-tags fa-fw mr-2"></i>Se pueden eliminar las cookies?
            </template>
            <p>
                Sí. No sólo eliminar, también bloquear, de forma general o particular para un dominio específico.
            </p>
            <p>
                Para eliminar las cookies de un sitio web debe ir a la configuración de su navegador y allí podrá buscar
                las asociadas al dominio en cuestión y proceder a su eliminación.
            </p>
        </b-card>

        <b-card class="mx-3 mb-3">
            <template v-slot:header>
                <i class="fa fa-tags fa-fw mr-2"></i>Configuraci&oacute;n de cookies para los navegadores m&aacute;s
                populares
            </template>
            <p>
                A continuación le indicamos cómo acceder a una cookie determinada del <b>navegador Chrome</b>.
                Nota: estos pasos pueden variar en función de la versión del navegador:
            </p>
            <ul>
                <li>Vaya a Configuración o Preferencias mediante el menú Archivo o bien pinchando el icono de
                    personalización que aparece arriba a la derecha.
                </li>
                <li>Verá diferentes secciones, pinche la opción Mostrar opciones avanzadas.</li>
                <li> Vaya a Privacidad, Configuración de contenido.</li>
                <li>Seleccione Todas las cookies y los datos de sitios.</li>
                <li>Aparecerá un listado con todas las cookies ordenadas por dominio. Para que le sea más fácil
                    encontrar las cookies de un determinado dominio introduzca parcial o totalmente la dirección en el
                    campo Buscar cookies.
                </li>
                <li>Tras realizar este filtro aparecerán en pantalla una o varias líneas con las cookies de la web
                    solicitada.
                </li>
                <li>Ahora sólo tiene que seleccionarla y pulsar la X para proceder a su eliminación.</li>
            </ul>
            <p>
                Para acceder a la configuración de cookies del <b>navegador Internet Explorer</b> siga estos pasos
                (pueden variar en función de la versión del navegador):
            </p>
            <ul>
                <li>Vaya a Herramientas, Opciones de Internet</li>
                <li>Haga click en Privacidad.</li>
                <li>Mueva el deslizador hasta ajustar el nivel de privacidad que desee.</li>
            </ul>
            <p>
                Para acceder a la configuración de cookies del <b>navegador Firefox</b> siga estos pasos
                (pueden variar en función de la versión del navegador):
            </p>
            <ul>
                <li>Vaya a Opciones o Preferencias según su sistema operativo.</li>
                <li>Haga click en Privacidad.</li>
                <li>En Historial elija Usar una configuración personalizada para el historial.</li>
                <li>Ahora verá la opción Aceptar cookies, puede activarla o desactivarla según sus preferencias.</li>
            </ul>
            <p>
                Para acceder a la configuración de cookies del <b>navegador Safari para OSX</b> siga estos pasos
                (pueden variar en función de la versión del navegador):
            </p>
            <ul>
                <li>Vaya a Preferencias, luego Privacidad.</li>
                <li>En este lugar verá la opción Bloquear cookies para que ajuste el tipo de bloqueo que desea
                    realizar.
                </li>
            </ul>
            <p>
                Para acceder a la configuración de cookies del <b>navegador Safari para iOS</b> siga estos pasos
                (pueden variar en función de la versión del navegador):
            </p>
            <ul>
                <li>Vaya a Ajustes, luego Safari.</li>
                <li>Vaya a Privacidad y Seguridad, verá la opción Bloquear cookies para que ajuste el tipo de bloqueo
                    que desea realizar.
                </li>
            </ul>

            <p>
                Para acceder a la configuración de cookies del <b>navegador para dispositivos Android</b> siga estos
                pasos
                (pueden variar en función de la versión del navegador):
            </p>
            <ul>
                <li>Ejecute el navegador y pulse la tecla Menú, luego Ajustes.</li>
                <li>Vaya a Seguridad y Privacidad, verá la opción Aceptar cookies para que active o desactive la
                    casilla.
                </li>
            </ul>
            <p>
                Para acceder a la configuración de cookies del <b>navegador para dispositivos Windows Phone</b> siga
                estos pasos (pueden variar en función de la versión del navegador):
            </p>
            <ul>
                <li>Abra Internet Explorer, luego Más, luego Configuración</li>
                <li>Ahora puede activar o desactivar la casilla Permitir cookies.</li>
            </ul>
        </b-card>

    </b-container>
</template>

<script>
    export default {
        name: "AboutCookiesPage"
    };
</script>

<style scoped>

</style>